export function assertIsString(
  value: unknown,
  message = "Not a string",
): asserts value is string {
  if (typeof value !== "string") throw new Error(message);
}
